module.exports = __webpack_public_path__ + "static/media/money.15d3e71d.svg";